export const checkObjectValue = (obj, value) =>
  Object.values(obj).includes(value)
